import { getUrl } from '../../../utils/api';

export const getVectorTileApi = () => {
  return getUrl(`map/tiles/{z}/{x}/{y}`);
};
